import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { ReactNode } from 'react';
import type { PageDataState } from './pageData.types';

const initialState: PageDataState = {
    explanationVideo: null,
    pageDescription: null,
};

export const pageDataSlice = createSlice({
    name: 'requestSlice',
    initialState: initialState,
    reducers: {
        setExplanationVideo: (
            state: PageDataState,
            action: PayloadAction<string>
        ) => {
            state.explanationVideo = action.payload;

            return state;
        },

        setPageData: (
            state: PageDataState,
            action: PayloadAction<{
                title: string;
                body: ReactNode;
            }>
        ) => {
            state.pageDescription = action.payload;

            return state;
        },

        resetPageData: () => {
            return initialState;
        },
    },
});

export const pageDataActions = {
    ...pageDataSlice.actions,
};
